<script>
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyamalzeme from "@/models/satdosyamalzeme";
import AddEdit from "./addedit.vue";
import talepmalzemeler from "./talepmalzemeler.vue";
import tekniksartnamekomisyonu from "./tekniksartnamekomisyonu.vue";
import ExcelOku from "./exceloku.vue";

export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric, satdosyamalzeme],
  page: {
    title: "Satın Alma Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    AddEdit,
    talepmalzemeler,
    tekniksartnamekomisyonu,
    ExcelOku
  },
  data() {
    return {
      title: this.$t("satdosyamalzeme.Title"),
      items: [
        {
          text: "",
          href: "/",
        },
        {
          text: "",
          active: true,
        },
        {
          text: this.$t("satdosyamalzeme.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      OlcuBirimleri: [],
      islem: 0,
      SiradakiNo: 1,
      Sno: 1,
      baglitalepler: [],
      tmdosyaid: "",
      onaybelgesi: 0,
      listeguncelle: 0,
      SatDosya: null
    };
  },
  created(){
    this.ActionsFilterGet({ Service: "SatOnayBelgesi", Page: this.Page, Filter: "&Dosyaid=" + this.satdosyaId }).then((res) => {
        this.onaybelgesi = res.Data.length;
      });
  },
  methods: {
    Get() {
      this.ActionsFilterGet({ Service: "SatDosyaMalzeme", Page: this.Page, Filter: "&Asc=Sirano&Dosyaid=" + this.satdosyaId }).then((res) => {
        this.TableData = res.Data;

        this.Page.PageDataSize = res.TotalCount;

        if (res.Data.length > 0) {
          this.SiradakiNo = this.TableData[res.TotalCount - 1].Sirano;
        } else {
          this.SiradakiNo = 0;
        }

        this.$emit("aktif_menu_title", this.$t("satdosyamalzeme.Title"));
      });

      this.ActionsSabitGet(201).then((res) => {
        this.OlcuBirimleri = [];

        for (var i = 0; i < res.Data.length; i++) {
          this.OlcuBirimleri.push({ Id: res.Data[i].Id, Value: res.Data[i].Value });
        }
      });

      this.ActionsSingleGet({ Service: "SatDosya", Id: this.satdosyaId }).then((res) => {
        this.SatDosya = res.Data;
      });
    },

    malzeme_sil(kayit_id) {
      let Filter = "&Satdosyamalzemeid=" + kayit_id;
      this.ActionsFilterGet({ Service: "SatTalepMalzeme", Page: this.Page, Filter: Filter }).then((res2) => {
        this.baglitalepler = res2.Data;

        for (var i = 0; i < this.baglitalepler.length; i++) {
          this.baglitalepler[i].Onaydurum = 3;
          this.baglitalepler[i].Satdosyamalzemeid = null;

          this.Update("SatTalep", { Id: this.baglitalepler[i].Talepid, Onaydurum: 5, Birimid: this.SatDosya.Ihaleyiyapanmakam }, false);
        }

        this.ActionsPutList({ Service: "SatTalepMalzeme/PutList", Data: this.baglitalepler }).then((res1) => {
          if (res1) {
            this.Delete("satdosyamalzeme", kayit_id);
          }
        });
      });
    },

    formkontrol() {
      this.listeguncelle = this.listeguncelle + 1;

      this.satdosyamalzemeData.Sirano = this.SiradakiNo + 1;

      this.satdosyamalzemeData.Malzemeid = null;
      this.satdosyamalzemeData.Olcubirimi = "";
      this.satdosyamalzemeData.Adet = 1;
      this.satdosyamalzemeData.Aciklama = "";
    },
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <!--  <div class="col-sm-4">
     
                    <h5>{{$t('satdosyamalzeme.Title')}}</h5>
                  </div> -->
            <div class="col-sm-12">
              <div class="text-sm-end">
                <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.tekniksartnamekomisyonu
                  @click="(islem = 3), (AddEdit = 'Add')"><i class="mdi mdi-plus-box-multiple me-1"></i>Teknik Şartname
                  Komisyonu</button>

                <button v-if="onaybelgesi == 0 && !SatDosya.Tamamlandi" type="button"
                  class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.satdosyamalzeme
                  @click="(islem = 1), formkontrol(), (DataUpdate = satdosyamalzemeData), (AddEdit = 'Add')"><i
                    class="mdi mdi-plus-box-multiple me-1"></i>{{ $t("satdosyamalzeme.Page.MalzemeEkle") }}</button>

                <button v-if="onaybelgesi == 0 && !SatDosya.Tamamlandi" type="button"
                  class="btn btn-secondary btn-rounded mb-2 me-2" v-b-modal.talepmalzemeler
                  @click="(islem = 2), (tmdosyaid = satdosyaId), formkontrol()"><i
                    class="mdi mdi-sort-bool-ascending-variant me-1"></i>{{ $t("satdosyamalzeme.Page.TaleplerdenEkle")
                    }}</button>
                    
                  <button
                    type="button"
                    class="btn btn-secondary rounded-pill mb-2 me-2"
                    v-b-modal.ExcelOku
                     @click="(DataUpdate = satdosyamalzemeData)"
                  >
                    <i class="mdi mdi-microsoft-excel me-1"></i> {{ this.$t("satdosyamalzeme.Page.ExcelOku") }}
                  </button>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t("satdosyamalzeme.Table.Sirano") }}</th>
                  <th>{{ $t("satdosyamalzeme.Table.MalzemeAdi") }}</th>
                  <th>{{ $t("satdosyamalzeme.Table.Birimi") }}</th>
                  <th>{{ $t("satdosyamalzeme.Table.Adet") }}</th>
                  <th v-if="onaybelgesi == 0">{{ $t("satdosyamalzeme.Table.Islem") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="Data in TableData" :key="Data.Id">
                  <td scope="row">{{ Data.Sirano }}</td>
                  <td scope="row">{{ Data.MalzemeAdi }}</td>
       
            <!--       <div v-for="birim in OlcuBirimleri" :key="birim.Id">
                      <div v-if="Data.Olcubirimi == birim.Id">{{ birim.Value }}</div>
                    </div> --> 
                    <td scope="row">{{ Data.Olcubirimiadi }}</td>
     
                  <td scope="row">{{ Data.Adet }}</td>
                  <td v-if="onaybelgesi == 0">
                    <i v-if="onaybelgesi == 0" class="fas fa-pencil-alt" v-b-modal.satdosyamalzeme
                      @click="(DataUpdate = Data), (AddEdit = 'Edit'), (islem = 1)"></i>&nbsp;
                    <i v-if="onaybelgesi == 0" class="fas fa-trash-alt" @click="malzeme_sil(Data.Id)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
              :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
              @input="ChangePage(DefaultPage)"> </b-pagination>
          </div>

          <AddEdit v-show="islem == 1" :Id="DataUpdate" :AddEdit="AddEdit" :getkontrol="listeguncelle"
            :satdosyaId="satdosyaId" @TableUpdate="Get" />

        <talepmalzemeler v-show="islem == 2" :SiradakiNo="SiradakiNo + 1" :satdosyaId="tmdosyaid" @TableUpdate="Get()" />

        <ExcelOku :Id="DataUpdate" @TableUpdate="Get()" :satdosyaId="satdosyaId"/>
        <yenimalzeme :Id="DataUpdate" :AddEdit="'AddEdit'" @TableUpdate="Get()" />
        <tekniksartnamekomisyonu v-show="islem == 3" :satdosyaId="satdosyaId" :Tamamlandi="SatDosya.Tamamlandi" />
      </div>
    </div>
  </div>
</div></template>
